import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';

import {
  Card, CardBody, Input, Progress,
} from 'reactstrap';

import FineUploaderTraditional from 'fine-uploader-wrappers';
import Gallery from 'react-fine-uploader';

import Dropzone from 'react-dropzone';

import DraftTitleAndBlurbContainer from '../containers/DraftTitleAndBlurbContainer';

const styles = {
  cardContainer: {
    marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
  },
  card: {
    minWidth: '37.5rem',
    maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
  },
  inputWrapper: {
    marginBottom: '1rem',
  },
  cardTitle: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
  },
  titleInput: {
    borderColor: '#E5E7E6',
  },
  description: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#979797',
    marginBottom: '0.3125rem',
  },
  blurb: {
    minHeight: '5.5rem',
    maxHeight: '5.5rem',
    resize: 'none',
    borderColor: '#E5E7E6',
  },
  cardFooterWrapper: {
    border: '1px solid #E5E7E6',
    cursor: 'pointer',
    padding: '0.75rem 0.8125rem 0.5rem 0.8125rem',
    borderRadius: '0.3125rem',
    backgroundColor: '#FFF',
  },
  icon: {
    color: '#979797',
    paddingRight: '0.5rem',
    composes: ['icon-camera'],
  },
  iconTextWrapper: {
    display: 'inline-block',
  },
  placeHolder: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#979797',
    display: 'inline-block',
    float: 'right',
  },
  chooseFile: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#34A5DA',
    display: 'inline-block',
    float: 'right',
  },
  dropzone: {
    width: "100%",
    height: 300,
    background: "#eee",
  },
  dropzoneInput: {
    width: "100%",
      height: "100%",
  },

  imagePreview: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top:0, 
    left: 0,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
  }
};

const uploader = new FineUploaderTraditional({
  options: {
    chunking: {
      enabled: true,
    },
    deleteFile: {
      enabled: true,
      endpoint: '/uploads',
    },
    request: {
      endpoint: '/uploads',
    },
    retry: {
      enableAuto: true,
    },
  },
});

const CreateDraftCard = (props) => {
  const { classes, description, type } = props;
  return (
    <Subscribe to={[DraftTitleAndBlurbContainer]}>
      { draftData => (
        <div className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardBody>
              <div className={classes.cardTitle}>
                {type} Jam Title:
              </div>
              <div className={classes.inputWrapper}>
                <Input className={classes.titleInput} onChange={draftData.handleChange} type="input" value={draftData.state.title || ''} name="title" id="title" placeholder="Write a jam Title..." />
              </div>
              <div className={classes.cardTitle}>
                {type} Jam Blurb:
              </div>
              <div className={classes.description}>
                {description}
              </div>
              <div className={classes.inputWrapper}>
                <Input className={classes.blurb} onChange={draftData.handleChange} type="textarea" value={draftData.state.blurb || ''} name="blurb" id="blurb" placeholder="Write a jam blurb..." />
              </div>

             <Dropzone
                onDrop={draftData.handleDropFile}
                onFileDialogCancel={draftData.handleFileDialogCancel}
                accept="image/jpeg, image/png"
                className={classes.dropzone}
                multiple={false}
                name="image"
                inputProps={{
                  className: classes.dropzoneInput
                }}
              >
                  <div className={classes.imagePreview} style={{
                    backgroundImage: `url(${draftData.state.image.url || draftData.state.image || draftData.state.image.preview})`
                  }}>
                  </div>
                <div className={classes.cardFooterWrapper}>
                  <div className={classes.iconTextWrapper}>
                    <i className={classes.icon} />
                    <div className={classes.placeHolder}> Upload a jam picture...</div>
                  </div>
                  <div className={classes.chooseFile}> Choose File </div>
                </div>
                <Progress animated value={draftData.state.completed} />

              </Dropzone>

              {/* <Gallery uploader={uploader} /> */}
            </CardBody>
          </Card>
        </div>
      )}
    </Subscribe>
  );
};

export default injectSheet(styles)(CreateDraftCard);



// WEBPACK FOOTER //
// ./src/components/CreateDraftCard.js